import {MCatChatAuthRequest} from "../../../services/mcatChat/types";
import {decodeToken} from "../../../utils/functions/decodeToken";

export interface AIMCATChatProps {
    theme: "light" | "dark";
}

export interface AIMCATMessage {
    id: string;
    content: string;
    isUser: boolean;
}

export type AI_MCAT_CHAT_MESSAGE_TYPE = "ERROR_CHAT_GENERATION" | "";
export type AI_MCAT_CHAT_STATE = "SELECT_SUBJECT" | "CHAT" | "FEEDBACK" | "TRANSITION_WARNING";

export const AI_MCAT_TEXT_TAGS = {
    CHAT_GENERATION_ERROR: ["<ERROR-AI_CHAT>", "</ERROR-AI_CHAT>"],
}

export const getUserAuthenticationBody = (): MCatChatAuthRequest => {
    const decodedToken = decodeToken();
    return {
        clientId: process.env.REACT_APP_MCAT_CHAT_CLIENT_ID ?? "",
        apiKey: process.env.REACT_APP_MCAT_CHAT_API_KEY ?? "",
        userId: decodedToken ? decodedToken.userid : null,
        userName: decodedToken ? decodedToken.username : "unknown"
    }
}